import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bdda5da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { id: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_CompTabs = _resolveComponent("CompTabs")!
  const _component_AnnouncementsBanner = _resolveComponent("AnnouncementsBanner")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_Guide = _resolveComponent("Guide")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasComps)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_AppHeader),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_CompTabs),
              (_ctx.showAnnouncementsBanner)
                ? (_openBlock(), _createBlock(_component_AnnouncementsBanner, {
                    key: 0,
                    onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAnnouncementsBanner = false))
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_DataGrid)
            ]),
            (_ctx.guideIsvisible === 'show')
              ? (_openBlock(), _createBlock(_component_Guide, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_AppFooter)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasComps && !_ctx.modalJumpStart.show && !_ctx.modalMLSImport.show)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          showLoadingText: true,
          loadingText: "Loading QuickSource..."
        }))
      : _createCommentVNode("", true),
    (_ctx.isSaving)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          showLBackDrop: true,
          showLoadingText: true,
          loadingText: "Saving..."
        }))
      : _createCommentVNode("", true),
    (_ctx.modalPhotoView.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalPhotoView.component), {
          key: 2,
          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalPhotoView.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.launchUserTutorialIntro.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.launchUserTutorialIntro.component), {
          key: 3,
          onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.launchUserTutorialIntro.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalUnVisitedComps.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalUnVisitedComps.component), {
          key: 4,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalUnVisitedComps.show = false)),
          comps: _ctx.modalUnVisitedComps.comps
        }, null, 8, ["comps"]))
      : _createCommentVNode("", true),
    (_ctx.modalJumpStart.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalJumpStart.component), {
          key: 5,
          onHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalJumpStart.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalMLSImport.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalMLSImport.component), {
          key: 6,
          onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalMLSImport.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalMLSImportPreviouslyViewed.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalMLSImportPreviouslyViewed.component), {
          key: 7,
          onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalMLSImportPreviouslyViewed.show = false)),
          previouslyVieweds: _ctx.modalMLSImportPreviouslyViewed.previouslyVieweds
        }, null, 8, ["previouslyVieweds"]))
      : _createCommentVNode("", true),
    (_ctx.modalConfirmation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfirmation.component), {
          key: 8,
          message: _ctx.modalConfirmation.message,
          buttons: _ctx.modalConfirmation.buttons,
          modalSize: _ctx.modalConfirmation.size,
          onHide: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalConfirmation.show = false)),
          includeModalHeader: _ctx.modalConfirmation.showModalHeader,
          title: _ctx.modalConfirmation.title
        }, null, 8, ["message", "buttons", "modalSize", "includeModalHeader", "title"]))
      : _createCommentVNode("", true),
    (_ctx.modalAnnouncements.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalAnnouncements.component), {
          key: 9,
          onHide: _ctx.closeAnnouncementsModal
        }, null, 8, ["onHide"]))
      : _createCommentVNode("", true)
  ], 64))
}